import { Injectable } from "@angular/core";
import { AcceptTrainingAsGuestModel } from "../models/training/accept-training-anonymous.model";

@Injectable({
  providedIn: 'root'
})
export class GuestRegistrationStorageService {
  private readonly storageKey = 'guest-details';

  get(): Partial<AcceptTrainingAsGuestModel> | null {
    const data = localStorage.getItem(this.storageKey);

    if (!data) {
      return null;
    }

    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }

  save(data: AcceptTrainingAsGuestModel): void {
    const guestRegistrationData: GuestRegistrationData = {
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      agentNumber: data.agentNumber,
      iddNumber: data.iddNumber,
      phoneMobile: data.phoneMobile,
      companyName: data.companyName
    };

    localStorage.setItem(
      this.storageKey, 
      JSON.stringify(guestRegistrationData)
    );
  }
}

interface GuestRegistrationData {
  email: string;
  firstName: string;
  lastName: string;
  agentNumber: string | null;
  iddNumber: string | null;
  phoneMobile: string | null;
  companyName: string | null;
}